export default __webpack_public_path__ + "static/media/BUPCIRCULAR.8040fbef.png";